import { HttpInterceptorFn, HttpResponse } from '@angular/common/http'
import { inject } from '@angular/core'
import { tap, catchError } from 'rxjs/operators'
import { throwError } from 'rxjs'
import { FreezeService } from '@educational-initiatives/angular-web-utilities'
import { environment } from 'src/environments/environment'

interface HeartbeatResponse {
    success?: boolean
    data?: {
        mode?: string
        redirect_url?: string
        message?: string
    }
}

export const heartbeatInterceptor: HttpInterceptorFn = (req, next) => {
    const freezeService = inject(FreezeService)

    return next(req).pipe(
        tap((event) => {
            if (event instanceof HttpResponse && req.url.includes('/sessions/heartbeat')) {
                const response = event.body as HeartbeatResponse | null

                if (response?.success && response.data) {
                    const { mode, redirect_url: redirectUrl, message } = response.data

                    switch (mode) {
                        case 'Redirect': {
                            // Only follow an explicit URL from the API. Do not fall back to
                            // ssoBaseUrl alone — that sends users to /en-IN/ even when logged in.
                            const target = redirectUrl?.trim() || environment.commonLoginUrl?.trim()
                            if (target) {
                                window.location.href = target
                            } else {
                                console.warn(
                                    '[heartbeat] Redirect mode without redirect_url; ignored.',
                                    message,
                                )
                            }
                            break
                        }

                        case 'Freeze':
                            freezeService.freezeUI(message ?? 'Assessment in progress')
                            break

                        case 'Default':
                            freezeService.unfreezeUI()
                            break

                        default:
                            console.warn('Unknown heartbeat mode:', mode)
                    }
                }
            }
        }),
        catchError((error) => throwError(() => error)),
    )
}
